import React from 'react';
import { useController } from 'react-hook-form';

import { TextField, TextFieldProps } from '@mui/material';

type Props = {
  name: string;
} & TextFieldProps;

export const Select = ({ children, name, label, ...muiSelectProps }: Props) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name });

  return (
    <TextField
      fullWidth
      select
      {...muiSelectProps}
      label={label}
      error={Boolean(error)}
      helperText={error?.message}
      {...field}
      value={field.value ?? ''}
    >
      {children}
    </TextField>
  );
};
